import { BasicContainer } from '@/components/Common/BasicContainer/BasicContainer';
import FormItem from '@/components/Common/FormItem/FormItem';
import { FormSectionTitle } from '@/components/Form/FormSectionTitle/FormSectionTitle';
import COLORS from '@/constants/colors';
import {
  Box,
  Button,
  Grid,
  MenuItem,
  Select,
  Stack,
  Switch,
  Typography,
} from '@mui/material';
import { MobileTimePicker } from '@mui/x-date-pickers';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { useDeliveryConfigurationViewController } from './DeliveryConfigurationViewController';

export function DeliveryConfiguration() {
  const { uiState, actions } = useDeliveryConfigurationViewController();

  return (
    <Stack spacing={'12px'} p={{ xs: '16px', md: '0px' }}>
      <FormSectionTitle title={'Configuracion de Entregas'} />
      <BasicContainer
        content={
          <Grid container columnSpacing={'20px'} rowSpacing={'12px'} p={'16px'}>
            <Grid item xs={12} md={6}>
              <FormItem label="Hora de corte para pedido al dia siguiente">
                <MobileTimePicker
                  sx={{ width: '100%', color: COLORS.gray_500 }}
                  value={uiState.nextDayCutOffTime}
                  onChange={actions.onCutoffTimeChanged}
                  closeOnSelect
                  ampm={false}
                  slotProps={{ textField: { fullWidth: true } }}
                />
              </FormItem>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormItem label="Pedido día siguiente">
                <Select
                  fullWidth
                  value={uiState.timePeriodSelected}
                  onChange={(e) =>
                    actions.onNextDayTimeSelected(e.target.value)
                  }
                >
                  {uiState.timePeriods.map((item) => (
                    <MenuItem key={item.value} value={item.value}>
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormItem>
            </Grid>
            {uiState.deliveryDays.map((deliveryDay) => (
              <Grid item key={`weekDay_${deliveryDay.dayId}`} xs={12} md={6}>
                <BasicContainer
                  content={
                    <Box p={'16px'}>
                      <Stack direction={'row'} alignItems={'center'}>
                        <Switch
                          checked={deliveryDay.enabled}
                          onChange={(e) =>
                            actions.onDeliveryDayCheckChanged(
                              deliveryDay.dayId,
                              e.target.checked
                            )
                          }
                        />
                        <Typography
                          sx={{
                            fontSize: '14px',
                            color: COLORS.gray_700,
                            fontWeight: 500,
                          }}
                        >
                          {deliveryDay.dayName}
                        </Typography>
                      </Stack>
                      {deliveryDay.enabled && (
                        <Stack
                          direction={'row'}
                          justifyContent={'space-between'}
                          spacing={'8px'}
                        >
                          <Stack width={'100%'}>
                            <Typography
                              sx={{
                                fontSize: '14px',
                                color: COLORS.gray_700,
                                fontWeight: 500,
                              }}
                            >
                              Horario entrega mínimo
                            </Typography>
                            <FormItem helperText={deliveryDay.errorMessage}>
                              <TimePicker
                                sx={{ width: '100%', color: COLORS.gray_500 }}
                                value={deliveryDay.minDeliveryTime}
                                onChange={(time) =>
                                  actions.onMinDeliveryTimeChanged(
                                    deliveryDay.dayId,
                                    time
                                  )
                                }
                                ampm={false}
                              />
                            </FormItem>
                          </Stack>
                          <Stack width={'100%'}>
                            <Typography
                              sx={{
                                fontSize: '14px',
                                color: COLORS.gray_700,
                                fontWeight: 500,
                              }}
                            >
                              Horario entrega máximo
                            </Typography>
                            <TimePicker
                              sx={{ width: '100%', color: COLORS.gray_500 }}
                              value={deliveryDay.maxDeliveryTime}
                              onChange={(time) =>
                                actions.onMaxDeliveryTimeChanged(
                                  deliveryDay.dayId,
                                  time
                                )
                              }
                              ampm={false}
                            />
                          </Stack>
                        </Stack>
                      )}
                    </Box>
                  }
                />
              </Grid>
            ))}
          </Grid>
        }
        footer={
          <Stack sx={{ flexDirection: 'row-reverse', p: '16px' }} gap={'16px'}>
            <Button
              variant="contained"
              disabled={uiState.saveDisabled}
              onClick={actions.onClickedSave}
            >
              Guardar cambios
            </Button>
            <Button
              variant="contained"
              disabled={uiState.cancelDisabled}
              onClick={actions.onClickedCancel}
            >
              Cancelar
            </Button>
          </Stack>
        }
      />
    </Stack>
  );
}
